<div class="language-switcher-inner" [ngClass]="{'collapsed':sidebarCollapsed}">
    <i class="fa fa-globe" aria-hidden="true"></i>
    <span>{{languageLabels[selected]}}</span>
    <select [(ngModel)]="selected" (change)="onChange()">
        <option *ngFor="let lang of options" [ngValue]="lang" >{{languageLabels[lang]}}</option>
    </select>
</div>
